<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>Vendor Name <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-select
        id="txtVendorId"
        v-model="clientExcursionManagementData.vendorSid"
        :items="clientExcursionManagementVendorsListView"
        item-title="name"
        item-value="sid"
        placeholder="Select Vendor Name"
        color="primary"
        persistent-placeholder
        :error-messages="vendorSidErrors"
        variant="solo"
        density="compact"
        @update:model-value="v$.clientExcursionManagementData.vendorSid.$touch()"
        @blur="v$.clientExcursionManagementData.vendorSid.$touch()"
      >
        <template #item="data">
          <v-list-item
            v-bind="data.props"
            :id="`client-individual-modal--excursion-management-vendor--vendor-name--option-${String(
              data.item.name
            ).replaceAll(' ', '')}`"
          >
            {{ data.item.name }}
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col cols="12">
      <span>Vendor Client SID <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtVendorClientSid"
        v-model="clientExcursionManagementData.vendorClientSid"
        variant="solo"
        density="compact"
        placeholder="Vendor Client SID"
        :error-messages="vendorClientSidErrors"
        @update:model-value="onClientSidChanged"
        @blur="onClientSidChanged"
        @keyup="autoPopulateVenderClientSid()"
      />
    </v-col>
    <v-col cols="12">
      <span>Vendor Client Name <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtVendorClientName"
        v-model="clientExcursionManagementData.vendorClientName"
        variant="solo"
        density="compact"
        placeholder="Vendor Client Name"
        :error-messages="vendorClientNameErrors"
        @update:model-value="v$.clientExcursionManagementData.vendorClientName.$touch()"
        @blur="v$.clientExcursionManagementData.vendorClientName.$touch()"
      />
    </v-col>
  </v-row>
  <v-row v-if="!isPcgNextGen" no-gutters>
    <v-col cols="12">
      <span>Excursion Management Vendor Webhook URL</span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="client-individual-modal--excursion-management-vendor-webhook-url--input"
        v-model="clientExcursionManagementData.excursionManagementVendorWebhookUrl"
        variant="solo"
        density="compact"
        placeholder="Excursion Management Vendor Webhook URL"
        :error-messages="excursionManagementVendorWebhookUrlErrors"
        @update:model-value="
          v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$touch()
        "
        @blur="v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$touch()"
      />
    </v-col>
  </v-row>
  <v-row no-gutters>
    <v-col cols="12">
      <span
        >Excursion Management Vendor Shared Secret Key
        <span v-if="isPcgNextGen" class="text-red">*</span></span
      >
    </v-col>
    <v-col cols="12" class="d-flex">
      <v-text-field
        id="client-individual-modal--excursion-management-vendor-shared-secret-key--input"
        v-model="clientExcursionManagementData.excursionManagementVendorSharedSecretKey"
        variant="solo"
        density="compact"
        placeholder="Excursion Management Vendor Shared Secret Key"
        :disabled="isPcgNextGen"
        :error-messages="vendorSecretKeyErrors"
        @update:model-value="onSecretKeyChanged"
      />
      <cs-button
        v-if="
          isPcgNextGen && clientExcursionManagementData.excursionManagementVendorSharedSecretKey
        "
        id="copy-secret-key-btn"
        primary
        left-icon="mdi-content-copy"
        class="mr-0"
        label="Copy"
        @click="copySecretKey"
      />
      <cs-button
        v-if="isPcgNextGen"
        id="generate-secret-key-btn"
        :primary="
          clientExcursionManagementData.excursionManagementVendorSharedSecretKey ? false : true
        "
        class="mr-0"
        left-icon="mdi-refresh"
        label="Generate"
        @click="showGenerateSecretKeyWarningDialog"
      />
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <v-checkbox
        id="cbxEnableVendorExcursionInput"
        v-model="clientExcursionManagementData.vendorExcursionSidInputEnabled"
        label="Enable Vendor Excursion SID Input"
        density="compact"
        color="primary"
      />
    </v-col>
    <v-col cols="12">
      <v-checkbox
        id="boardingSupportEnabledCheckbox"
        v-model="clientExcursionManagementData.boardingSupportEnabled"
        class="client-individual-checkbox"
        label="Enable Boarding Support"
        density="compact"
        color="primary"
      />
    </v-col>
    <v-col cols="12">
      <span>School Types</span>
    </v-col>
    <v-col cols="12">
      <v-card class="pa-2" border flat>
        <v-row justify="space-between">
          <v-col cols="10">
            <v-text-field
              id="newSchoolType"
              v-model="newSchoolType.name"
              variant="solo"
              density="compact"
              placeholder="Eg. Junior School or Primary"
              :error-messages="newSchoolType.errorMessage"
            />
          </v-col>
          <v-col cols="1" class="mr-2">
            <cs-button id="btnAddSchoolType" small label="Add" @click="addSchoolType" />
          </v-col>
        </v-row>
        <v-row
          v-for="(school, index) in clientExcursionManagementData.schoolTypes"
          :key="index"
          justify="space-between"
        >
          <v-col cols="10">
            <v-text-field
              :id="getSchoolTypeTxtFieldId(index)"
              v-model="school.name"
              variant="solo"
              density="compact"
              placeholder="Eg. Junior School or Primary"
              :error-messages="school.errorMessage"
              validate-on="input"
              @update:model-value="changeSchoolType(school, index)"
              @change="showSchoolTypeWarning"
            />
          </v-col>
          <v-col cols="1" class="mr-2">
            <cs-button
              :id="`btnDeleteSchoolButton${index}`"
              small
              delete
              label="Delete"
              :disabled="school.errorMessage?.length > 0"
              @click="deleteSchoolType(school)"
            ></cs-button>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
  <v-spacer></v-spacer>
  <v-row>
    <v-col cols="12" class="d-flex justify-end align-center pr-1">
      <cs-button
        v-if="editMode === 'update'"
        id="btnSaveExcursionManagement"
        primary
        label="Save Excursion Management"
        :disabled="saveButtonDisabled"
        :loading="saveActionInProgress"
        @click="onSave()"
      ></cs-button>
    </v-col>
  </v-row>
  <cs-form-dialog
    id="dlg-client-ind-editor-excursion-management"
    v-model="noticeDialogDisplayed"
    body-id="dlg-client-ind-editor-excursion-management"
    heading="Client Excursion Management Editor"
    :primary-action="{
      label: 'OK',
      eventName: 'primary-click'
    }"
    @primary-click="onDialogOkBtn"
  >
    <template #cs-form-dialog-content>
      <div v-safe-html="noticeDialogMessage"></div>
      <v-spacer></v-spacer>
      <div v-safe-html="noticeDialogWarningMessage" class="warning-message"></div>
    </template>
  </cs-form-dialog>
  <cs-form-dialog
    id="dlg-client-ind-editor-excursion-management-generate-secret-key-warning"
    v-model="generateSecretKeyWarningDialogDisplayed"
    body-id="dlg-body-client-ind-editor-excursion-management-generate-secret-key-warning"
    heading="Generate Secret Key Warning"
    :primary-action="{
      label: 'OK',
      eventName: 'primary-click'
    }"
    :secondary-action1="{
      label: 'Cancel',
      eventName: 'secondary1-click'
    }"
    @primary-click="generateSecretKey"
    @secondary1-click="generateSecretKeyWarningDialogDisplayed = false"
  >
    <template #cs-form-dialog-content>
      <div>
        There is a secret key already set for this client. Are you sure you want to generate a new
        one?
      </div>
    </template>
  </cs-form-dialog>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '@/store/mutationTypes';
import { validateUrl, validateKebabCasedString } from './validation';

export default {
  name: 'ClientExcursionManagement',
  extends: CSBase,
  props: {
    clientSid: {
      type: String,
      required: false,
      default: ''
    },
    showVendorClientSidConflict: {
      type: Boolean,
      required: false,
      default: false
    },
    showVendorSecretKeyConflict: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: [
    'clientExcursionManagementChanged',
    'showSchoolTypeWarning',
    'isValidSchoolType',
    'clientExcursionManagementSaved',
    'update:showVendorSecretKeyConflict',
    'update:showVendorClientSidConflict'
  ],
  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      clientExcursionManagementData: {
        vendorSid: {
          required
        },
        vendorClientName: {
          required
        },
        excursionManagementVendorWebhookUrl: {
          validateExcursionManagementVendorWebhookUrl: validateUrl
        },
        vendorClientSid: {
          required,
          validateKebabCasedString
        },
        excursionManagementVendorSharedSecretKey: {
          required: (value) => {
            if (!this.isPcgNextGen) {
              return true;
            }
            return !!value;
          }
        }
      }
    };
  },

  data() {
    return {
      editMode: {
        type: String,
        required: false,
        default: 'create'
      },
      clientExcursionManagementData: {
        vendorSid: null,
        vendorClientSid: '',
        vendorClientName: '',
        excursionManagementVendorWebhookUrl: '',
        excursionManagementVendorSharedSecretKey: '',
        vendorExcursionSidInputEnabled: false,
        boardingSupportEnabled: false,
        schoolTypes: []
      },
      excursionManagementVendors: [],
      newSchoolType: {},
      vendorClientSidConflicted: false,
      vendorSecretKeyConflicted: false,
      saveActionInProgress: false,
      noticeDialogDisplayed: false,
      noticeDialogMessage: '',
      largestSchoolTypeId: 0,
      disableSaveButton: false,
      generateSecretKeyWarningDialogDisplayed: false
    };
  },

  computed: {
    ...mapGetters({
      clientExcursionManagementView: 'clients/clientExcursionManagementView',
      clientExcursionManagementVendorsListView: 'clients/clientExcursionManagementVendorsListView'
    }),
    vendorSidErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorSid.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorSid.required.$invalid) {
        errors.push('Vendor Name is required');
      }
      return errors;
    },
    vendorClientNameErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorClientName.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorClientName.required.$invalid) {
        errors.push('Vendor Client Name is required');
      }
      return errors;
    },
    excursionManagementVendorWebhookUrlErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl.$dirty)
        return errors;
      if (
        this.v$.clientExcursionManagementData.excursionManagementVendorWebhookUrl
          .validateExcursionManagementVendorWebhookUrl.$invalid
      ) {
        errors.push('Invalid Excursion Management Vendor Webhook URL');
      }
      return errors;
    },
    vendorClientSidErrors() {
      const errors = [];
      if (!this.v$.clientExcursionManagementData.vendorClientSid.$dirty) return errors;
      if (this.v$.clientExcursionManagementData.vendorClientSid.required.$invalid) {
        errors.push('Vendor Client SID is required');
      } else if (
        this.v$.clientExcursionManagementData.vendorClientSid.validateKebabCasedString.$invalid
      ) {
        errors.push('Vendor Client SID must be a kebab-cased string');
      } else if (this.vendorClientSidConflicted) {
        errors.push('Vendor Client SID conflicted');
      }
      return errors;
    },
    vendorSecretKeyErrors() {
      const errors = [];
      if (this.vendorSecretKeyConflicted) {
        errors.push('Vendor Secret Key conflicted');
        return errors;
      }
      if (!this.v$.clientExcursionManagementData.excursionManagementVendorSharedSecretKey.$dirty)
        return errors;
      if (
        this.v$.clientExcursionManagementData.excursionManagementVendorSharedSecretKey.required
          .$invalid
      ) {
        errors.push('Secret Key must not be empty');
      }
      return errors;
    },
    saveButtonDisabled() {
      return (
        this.v$.$invalid ||
        this.saveActionInProgress ||
        this.disableSaveButton ||
        this.vendorClientSidConflicted ||
        this.vendorSecretKeyConflicted
      );
    },
    isPcgNextGen() {
      let moduleName = '';
      const vendor = this.clientExcursionManagementVendorsListView?.find(
        (vendor) => vendor.sid === this.clientExcursionManagementData.vendorSid
      );
      if (vendor) {
        moduleName = vendor.moduleName || vendor.name;
      }
      return moduleName === 'pcg-nextgen';
    }
  },

  watch: {
    clientExcursionManagementData: {
      handler() {
        this.$emit('clientExcursionManagementChanged', this.clientExcursionManagementData);
      },
      deep: true
    },
    // @TODO to allow SaveAll to show vendor client sid conflict. To be removed after consolidation
    showVendorClientSidConflict() {
      this.vendorClientSidConflicted = this.showVendorClientSidConflict;
    },
    showVendorSecretKeyConflict() {
      this.vendorSecretKeyConflicted = this.showVendorSecretKeyConflict;
    }
  },

  async mounted() {
    await this.$store.dispatch('clients/fetchClientExcursionManagementVendorsList');
    await this.initPage(this.clientSid);
    if (this.clientExcursionManagementData?.schoolTypes?.length > 0) {
      this.largestSchoolTypeId = Math.max(
        ...this.clientExcursionManagementData.schoolTypes.map((s) => s.id)
      );
    } else {
      this.largestSchoolTypeId = 0;
    }
  },

  methods: {
    getSchoolTypeTxtFieldId(index) {
      return `client-individual-modal--school-type--text-input-${index}`;
    },
    autoPopulateVenderClientSid() {
      if (!this.clientExcursionManagementData.vendorClientSid && this.clientSid) {
        this.clientExcursionManagementData.vendorClientSid = this.clientSid;
      }
    },
    async initPage(clientSid) {
      if (clientSid) {
        this.editMode = 'update';
        await this.fetchExcursionManagement();
        this.reloadData();
      }
    },
    async fetchExcursionManagement() {
      try {
        if (this.clientSid) {
          this.setLoading(true);
          await this.$store.dispatch('clients/fetchClientExcursionManagement', this.clientSid);
          this.clearLoading();
        }
      } catch (e) {
        this.clearLoading();
      }
    },
    reloadData() {
      const {
        activeVendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      } = cloneDeep(this.clientExcursionManagementView);
      this.clientExcursionManagementData = {
        vendorSid: activeVendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      };
    },
    showSchoolTypeWarning() {
      if (this.clientSid) {
        this.$emit('showSchoolTypeWarning');
      }
    },
    changeSchoolType(school) {
      const trimmedSchoolName = school.name?.trim();
      if (!trimmedSchoolName) {
        school.errorMessage = ['School Name is required'];
        this.$forceUpdate();
        this.disableSaveButton = true;
        this.$emit('isValidSchoolType', false);
        return;
      }
      if (
        this.clientExcursionManagementData.schoolTypes?.some(
          (s) => s.name.toLowerCase() === trimmedSchoolName.toLowerCase() && s.id !== school.id
        )
      ) {
        school.errorMessage = ['School Name conflicted'];
        this.$forceUpdate();
        this.disableSaveButton = true;
        this.$emit('isValidSchoolType', false);
        return;
      }
      delete school.errorMessage;
      this.disableSaveButton = false;
      this.$emit('isValidSchoolType', true);
    },
    addSchoolType() {
      this.newSchoolType.name = this.newSchoolType.name?.trim();
      if (!this.newSchoolType.name) {
        this.newSchoolType.errorMessage = ['School Name is required'];
        return;
      }
      if (
        this.clientExcursionManagementData.schoolTypes?.some(
          (s) => s.name.toLowerCase() === this.newSchoolType.name.toLowerCase()
        )
      ) {
        this.newSchoolType.errorMessage = ['School Name conflicted'];
        return;
      }
      this.largestSchoolTypeId = this.largestSchoolTypeId + 1;
      this.newSchoolType.id = this.largestSchoolTypeId.toString();
      this.newSchoolType.errorMessage = [];
      this.clientExcursionManagementData.schoolTypes.push({
        id: this.newSchoolType.id,
        name: this.newSchoolType.name
      });
      this.newSchoolType = {};
      this.showSchoolTypeWarning();
    },
    deleteSchoolType(school) {
      this.clientExcursionManagementData.schoolTypes =
        this.clientExcursionManagementData.schoolTypes.filter((s) => s.id !== school.id);
      this.showSchoolTypeWarning();
    },
    async saveClientExcursionManagement() {
      const {
        vendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      } = this.clientExcursionManagementData;
      const clientExcursionManagementPayload = {
        activeVendorSid: vendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      };
      if (this.isPcgNextGen) {
        delete clientExcursionManagementPayload.excursionManagementVendorWebhookUrl;
      }
      const patchRes = await this.$store.dispatch('clients/patchClientExcursionManagement', {
        clientSid: this.clientSid,
        clientExcursionManagement: clientExcursionManagementPayload
      });
      return patchRes;
    },
    async onSave() {
      this.saveActionInProgress = true;
      this.vendorClientSidConflicted = false;
      this.vendorSecretKeyConflicted = false;
      try {
        this.$store.commit('app/setSilentAxiosError', true);
        const saveClientExcursionManagementRes = await this.saveClientExcursionManagement();
        if (
          !saveClientExcursionManagementRes ||
          saveClientExcursionManagementRes.status !== 'success'
        ) {
          this.saveActionInProgress = false;
          this.handleSaveError(saveClientExcursionManagementRes.error);
          return;
        }
        this.alertSaveResult('success');
        await this.fetchExcursionManagement();
        this.$emit('clientExcursionManagementSaved', true);
      } catch (error) {
        this.handleSaveError(error);
      } finally {
        this.saveActionInProgress = false;
      }
    },
    alertSaveResult(status, errorMessage, warningMessage) {
      this.$store.commit(types.COMMON_SET_IS_RESPONSE_WITH_ERROR, false);
      if (status === 'success') {
        this.noticeDialogMessage = 'Excursion Management Setting has been saved.';
        this.noticeDialogWarningMessage = warningMessage || '';
      } else {
        this.noticeDialogMessage = errorMessage || `Failed to save Client information.`;
        this.noticeDialogWarningMessage = warningMessage || '';
      }
      this.noticeDialogDisplayed = true;
    },
    handleSaveError(error) {
      let displayMessage = error.message || '';
      let warningMessage = '';
      let errCaseSid = '';
      try {
        const errorMessages = error.message?.split(':') || [];
        if (errorMessages.length > 3) {
          // eslint-disable-next-line prefer-destructuring
          displayMessage = `Save Error: ${errorMessages[2]}`;
          warningMessage = `errorRefId: ${errorMessages[1]}`;
          errCaseSid = errorMessages[3] ? errorMessages[3].trim() : '';
        }
        if (error.statusCode === 409) {
          if (errCaseSid === 'EXCURSION_VENDOR_SECRET_KEY_CONFLICTED') {
            this.vendorSecretKeyConflicted = true;
            this.$emit('update:showVendorSecretKeyConflict', true);
          } else {
            this.vendorClientSidConflicted = true;
            this.$emit('update:showVendorClientSidConflict', true);
          }
        }
        this.alertSaveResult(
          'error',
          `Failed to save Client information. <br/> ${displayMessage}`,
          warningMessage
        );
      } finally {
        this.$store.commit('app/setSilentAxiosError', true);
      }
    },
    onDialogOkBtn() {
      this.noticeDialogDisplayed = false;
    },
    onSecretKeyChanged() {
      this.v$.clientExcursionManagementData.excursionManagementVendorSharedSecretKey.$touch();
      this.vendorSecretKeyConflicted = false;
      this.$emit('update:showVendorSecretKeyConflict', false);
    },
    onClientSidChanged() {
      this.v$.clientExcursionManagementData.vendorClientSid.$touch();
      this.vendorClientSidConflicted = false;
      this.$emit('update:showVendorClientSidConflict', false);
    },
    async showGenerateSecretKeyWarningDialog() {
      if (this.clientExcursionManagementData.excursionManagementVendorSharedSecretKey) {
        this.generateSecretKeyWarningDialogDisplayed = true;
      } else {
        await this.generateSecretKey();
      }
    },
    async generateSecretKey() {
      const data = await this.$store.dispatch('clients/generateClientSecretKey');
      this.clientExcursionManagementData.excursionManagementVendorSharedSecretKey = data?.secretKey;
      this.generateSecretKeyWarningDialogDisplayed = false;
    },
    copySecretKey() {
      navigator.clipboard.writeText(
        this.clientExcursionManagementData.excursionManagementVendorSharedSecretKey
      );
      this.showInfoAlert('Secret Key has been copied to clipboard.');
    }
  }
};
</script>
